export const REQUEST_USER_LOGIN = "REQUEST_USER_LOGIN";
export const USER_LOGGED_IN = "USER_LOGGED_IN";
export const LOGOUT_USER = "LOGOUT_USER";
export const SET_USER_ROLE = "SET_USER_ROLE";
